export default "__VITE_ASSET__EKeerwVb__"